/**
 * FeedbackNotificationQueueService
 * Service for FeedbackNotificationQueue entity operations
 * Route: api/feedbacknotificationqueue
 */
import { CrudService } from '../base/CrudService';
/**
 * FeedbackNotificationQueueService
 * Handles notification queue CRUD operations
 */
export class FeedbackNotificationQueueService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FeedbackNotificationQueueService.DEFAULT_SERVICE_PATH,
            basePath: FeedbackNotificationQueueService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET UNPROCESSED ====================
    /**
     * Get all unprocessed notifications
     * GET api/feedbacknotificationqueue/unprocessed
     */
    async getUnprocessed() {
        const response = await this.getUnprocessedRaw();
        return response.data ?? [];
    }
    /**
     * Get all unprocessed notifications with full response
     */
    getUnprocessedRaw() {
        const endpoint = this.getEndpoint('unprocessed', 'unprocessed');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== MARK PROCESSED ====================
    /**
     * Mark notification as processed
     * PUT api/feedbacknotificationqueue/{id}/process
     */
    async markProcessed(id) {
        const response = await this.markProcessedRaw(id);
        if (!response.data) {
            throw new Error(`Failed to mark notification ${id} as processed`);
        }
        return response.data;
    }
    /**
     * Mark notification as processed with full response
     */
    markProcessedRaw(id) {
        const endpoint = this.getEndpoint('mark-processed', `${id}/process`);
        const url = this.buildUrl(endpoint);
        return this.http.put(url, {});
    }
}
FeedbackNotificationQueueService.DEFAULT_SERVICE_PATH = 'feedback';
FeedbackNotificationQueueService.BASE_PATH = 'api/feedbacknotificationqueue';
//# sourceMappingURL=FeedbackNotificationQueueService.js.map